import { makeRequest } from '../base/axios.ts'

export default {
  createFlag: function (flaggableType, flaggableId) {
    // create the object that we intend to send to the server
    const data = {
      flag: {
        flaggable_id: flaggableId,
        flaggable_type: flaggableType,
      },
    }
    return makeRequest({
      url: '/api/v1/flags',
      method: 'post',
      data,
      requestId: `create-flag-${flaggableType}-${flaggableId}`,
    })
  },
}
